module.exports = __webpack_public_path__ + "assets/img/qrcode.10c7d6c9.png";